export default __webpack_public_path__ + "static/stats-73084699bcb471ef66d730ed568cc3f9.png";